<template>
	<div>
		<Header></Header>
		<div id="main_content" style="overflow: hidden;">
			<LeftSide v-if="geted_login_status"></LeftSide>
			<RightSide v-if="geted_login_status"></RightSide>
		</div>
	</div>
</template>

<script>
	import Header from './Header.vue';
	import LeftSide from './LeftSide.vue';
	import RightSide from './RightSide.vue';
	export default {
		name: 'Page',
		components: {
			Header,
			LeftSide,
			RightSide
		},
		data: function() {
			return {
				geted_login_status: false
			}
		},
		mounted: function() {

		},
		created: function() {
			if (this.$store.state.user.id && this.$store.state.user.yhm) {
				this.geted_login_status = true;
			} else {
				//判断当前回话是否登录，如果登录则取出缓存的用户状态数据
				this.$http.post("/htgl/isLogin").then(res => {
					this.geted_login_status = true;
					if (res.data) {
						if (localStorage.getItem("jxjy_store_user")) {
							this.$store.commit('setUser',
								JSON.parse(localStorage.getItem("jxjy_store_user")));
						}
						if (localStorage.getItem("jxjy_store_privileges")) {
							this.$store.commit('setPrivileges',
								JSON.parse(localStorage.getItem("jxjy_store_privileges")));
						}
						if (localStorage.getItem("jxjy_store_privilege_codes")) {
							this.$store.commit('setPrivilegeCodes',
								JSON.parse(localStorage.getItem("jxjy_store_privilege_codes")));
						}
						if (sessionStorage.getItem("jxjy_store_breadcrumbs")) {
							this.$store.commit('setBreadcrumb',
								JSON.parse(sessionStorage.getItem("jxjy_store_breadcrumbs")));
						}
						if (sessionStorage.getItem("jxjy_store_currentMenus")) {
							this.$store.commit('setCurrentMenus',
								JSON.parse(sessionStorage.getItem("jxjy_store_currentMenus")));
						}
						if (sessionStorage.getItem("jxjy_store_activeMenu")) {
							this.$store.commit('setActiveMenu',
								JSON.parse(sessionStorage.getItem("jxjy_store_activeMenu")));
						}
						if (sessionStorage.getItem("jxjy_store_activeModule")) {
							this.$store.commit('setActiveModule',
								sessionStorage.getItem("jxjy_store_activeModule"));
						}
						this.initMenu();
					}
				});
			}
		},
		methods: {
			doOkCallback:function(){
				let message = this.$store.state.message || {};
				if(message && message.okCallBack){
					message.okCallBack.call(this);
				}
				this.hideMessage();
			},
			doCancelCallback:function(){
				let message = this.$store.state.message || {};
				if(message && message.cancelCallBack){
					message.cancelCallBack.call(this);
				}
				this.hideMessage();
			},
			hideMessage: function() {
				this.$store.commit('setMessage',{});
			},
			initMenu: function() {
				if (!sessionStorage.getItem("jxjy_store_currentMenus")) {
					let privileges = JSON.parse(localStorage.getItem("jxjy_store_privileges"));
					//默认展示第一个模块的第一个导航的菜单
					if (privileges && privileges.length > 0) {
						let modules = privileges.filter(x => x.type == 'module');
						if (modules && modules.length > 0) {
							let defaultModule = modules[0];
							if (defaultModule && defaultModule.children && defaultModule.children.length > 0) {
								this.$store.commit('setActiveModule', defaultModule.code);
								let navs = defaultModule.children.filter(x => x.type == 'nav');
								if (navs && navs.length > 0) {
									let defaultNav = navs[0];
									if (defaultNav && defaultNav.children && defaultNav.children.length > 0) {
										let menus = defaultNav.children.filter(x => x.type == 'menu');
										if (menus && menus.length > 0) {
											this.$store.commit('setCurrentMenus', menus);
										}
									}
								} else {
									//直接获取module下的菜单
									let menuList = defaultModule.children.filter(x => x.type == 'menu');
									if (menuList && menuList.length > 0) {
										this.$store.commit('setCurrentMenus', menuList);
									}
								}
							}
						}

					}
				}
			}
		}
	}
</script>

<style>
	.coursor-hand {
		cursor: pointer;
	}

	.modal-open {
		overflow-y: auto;
	}

	.fixed-table-body {
		height: auto !important;
	}

	.fixed-table-container {
		border-bottom: 0px !important;
	}

	.boot_table_row_selected {
		background-color: #f5f5f5;
		font-weight: 900;
	}
</style>
